import React, { useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ThreeCircles } from "react-loader-spinner";
import { BASE_URL } from "../../Shared/URL";
import Swal from "sweetalert2";

export default function Register() {
  const user = {
    firstName: "",
    lastName: "",
    userName: "",
    email: "",
    phoneNumber: "",
    password: "",
  };

  const [ErrorMsg, setErrorMsg] = useState(null);
  const [SuccessMsg, setSuccessMsg] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  async function SendData(values) {
    setIsLoading(true);

    try {
      const token = localStorage.getItem("__inventory_sys_auth_token_5f9dA72xQp__");

      if (!token) {
        Swal.fire({
          title: "خطأ!",
          text: "لم يتم العثور على التوكن. يرجى تسجيل الدخول مرة أخرى.",
          icon: "error",
        });
        setIsLoading(false);
        return;
      }

      let { data } = await axios.post(
        `${BASE_URL}/Account/register`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccessMsg("تم إنشاء الحساب بنجاح 🎉");

      setTimeout(() => navigate("/alladmin"), 1000);
    } catch (error) {
      const apiMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "حدث خطأ غير متوقع";

      setErrorMsg(apiMessage);
    }

    setIsLoading(false);
  }

  function validate(values) {
    const errors = {};
    setErrorMsg(null);

    if (!values.firstName.trim()) errors.firstName = "الاسم الأول مطلوب";

    if (!values.lastName.trim()) errors.lastName = "اسم العائلة مطلوب";

    if (values.userName.length < 3)
      errors.userName = "اسم المستخدم يجب أن يكون 3 أحرف على الأقل";

    if (!values.email.includes("@") || !values.email.includes("."))
      errors.email = "صيغة الإيميل غير صحيحة";

    if (
      !values.password.match(
        /(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/
      )
    ) {
      errors.password =
        "يجب أن تحتوي كلمة السر على حرف كبير وصغير ورقم وألا تقل عن 8 أحرف";
    }

    if (!values.phoneNumber.match(/^(01)[0-9]{9}$/)) {
      errors.phoneNumber = "رقم الهاتف يجب أن يكون 11 رقم ويبدأ بـ 01";
    }

    return errors;
  }

  const formikObject = useFormik({
    initialValues: user,
    validate,
    onSubmit: SendData,
  });

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        background: "#f1f5f9",
        paddingTop: "40px",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "40px",
          borderRadius: "12px",
          width: "100%",
          maxWidth: "650px",
          boxShadow: "0 4px 12px rgba(37, 99, 235, 0.15)",
        }}
      >
        <h2
          style={{
            color: "#2563eb",
            fontWeight: "700",
            marginBottom: "25px",
            textAlign: "center",
          }}
        >
          إضافة مشرف جديد
        </h2>

        {SuccessMsg && (
          <div className="alert alert-success text-center">{SuccessMsg}</div>
        )}

        {ErrorMsg && (
          <div className="alert alert-danger text-center">{ErrorMsg}</div>
        )}

        <form onSubmit={formikObject.handleSubmit}>
          {/* First Name */}
          <label style={{ fontWeight: "600", color: "#475569" }}>
            الاسم الأول
          </label>
          <input
            type="text"
            name="firstName"
            className="form-control mb-3 mt-2"
            value={formikObject.values.firstName}
            onChange={formikObject.handleChange}
            onBlur={formikObject.handleBlur}
            style={{ padding: "12px", fontSize: "16px" }}
          />
          {formikObject.errors.firstName && formikObject.touched.firstName && (
            <div className="alert alert-danger py-2">
              {formikObject.errors.firstName}
            </div>
          )}

          {/* Last Name */}
          <label style={{ fontWeight: "600", color: "#475569" }}>
            اسم العائلة
          </label>
          <input
            type="text"
            name="lastName"
            className="form-control mb-3 mt-2"
            value={formikObject.values.lastName}
            onChange={formikObject.handleChange}
            onBlur={formikObject.handleBlur}
            style={{ padding: "12px", fontSize: "16px" }}
          />
          {formikObject.errors.lastName && formikObject.touched.lastName && (
            <div className="alert alert-danger py-2">
              {formikObject.errors.lastName}
            </div>
          )}

          {/* Username */}
          <label style={{ fontWeight: "600", color: "#475569" }}>
            اسم المستخدم
          </label>
          <input
            type="text"
            name="userName"
            className="form-control mb-3 mt-2"
            value={formikObject.values.userName}
            onChange={formikObject.handleChange}
            onBlur={formikObject.handleBlur}
            style={{ padding: "12px", fontSize: "16px" }}
          />
          {formikObject.errors.userName && formikObject.touched.userName && (
            <div className="alert alert-danger py-2">
              {formikObject.errors.userName}
            </div>
          )}

          {/* Email */}
          <label style={{ fontWeight: "600", color: "#475569" }}>الإيميل</label>
          <input
            type="email"
            name="email"
            className="form-control mb-3 mt-2"
            value={formikObject.values.email}
            onChange={formikObject.handleChange}
            onBlur={formikObject.handleBlur}
            style={{ padding: "12px", fontSize: "16px" }}
          />
          {formikObject.errors.email && formikObject.touched.email && (
            <div className="alert alert-danger py-2">
              {formikObject.errors.email}
            </div>
          )}

          {/* Phone */}
          <label style={{ fontWeight: "600", color: "#475569" }}>
            رقم الهاتف
          </label>
          <input
            type="tel"
            name="phoneNumber"
            className="form-control mb-3 mt-2"
            value={formikObject.values.phoneNumber}
            onChange={formikObject.handleChange}
            onBlur={formikObject.handleBlur}
            style={{ padding: "12px", fontSize: "16px" }}
          />
          {formikObject.errors.phoneNumber &&
            formikObject.touched.phoneNumber && (
              <div className="alert alert-danger py-2">
                {formikObject.errors.phoneNumber}
              </div>
            )}

          {/* Password */}
          <label style={{ fontWeight: "600", color: "#475569" }}>
            كلمة المرور
          </label>
          <input
            type="password"
            name="password"
            className="form-control mb-4 mt-2"
            value={formikObject.values.password}
            onChange={formikObject.handleChange}
            onBlur={formikObject.handleBlur}
            style={{ padding: "12px", fontSize: "16px" }}
          />
          {formikObject.errors.password && formikObject.touched.password && (
            <div className="alert alert-danger py-2">
              {formikObject.errors.password}
            </div>
          )}

          {/* Button */}
          <button
            type="submit"
            disabled={!(formikObject.dirty && formikObject.isValid)}
            style={{
              width: "100%",
              background: "#2563eb",
              padding: "12px",
              borderRadius: "8px",
              border: "none",
              color: "#fff",
              fontWeight: "600",
              fontSize: "18px",
              marginTop: "10px",
            }}
          >
            {IsLoading ? (
              <ThreeCircles height="50" width="80" color="#fff" />
            ) : (
              "إضافة مشرف"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
